import { isNetworkError } from './netFetch'

/**
 * The three failure modes worth wording differently in the UI.
 *
 *  - `offline`     the device has no working connection
 *  - `unreachable` the connection works but nothing answered
 *  - `error`       the server answered, and the answer was bad news
 *
 * Collapsing these into one "something went wrong" is how you end up telling
 * someone on solid wifi to check their connection because a backend threw a 500.
 */
export type ErrorKind = 'offline' | 'unreachable' | 'error'

export function classifyError(error: unknown, offline: boolean): ErrorKind {
  if (offline) return 'offline'
  if (isNetworkError(error)) return error.offline ? 'offline' : 'unreachable'
  return 'error'
}
